var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0083 2.16602C6.47396 2.16602 2 6.67296 2 12.2487C2 16.7056 4.86662 20.4783 8.84338 21.8136C9.34058 21.914 9.5227 21.5967 9.5227 21.3297C9.5227 21.096 9.50631 20.2948 9.50631 19.46C6.72225 20.061 6.14249 18.258 6.14249 18.258C5.69508 17.0895 5.03215 16.7892 5.03215 16.7892C4.12092 16.1715 5.09852 16.1715 5.09852 16.1715C6.1093 16.2383 6.63969 17.2065 6.63969 17.2065C7.53432 18.7421 8.97592 18.3082 9.55588 18.0411C9.63865 17.39 9.90394 16.9394 10.1856 16.689C7.96514 16.4553 5.62891 15.5873 5.62891 11.7144C5.62891 10.6126 6.02634 9.71125 6.65608 9.01021C6.55672 8.75987 6.20866 7.72471 6.75564 6.33924C6.75564 6.33924 7.60069 6.0721 9.5061 7.37419C10.3219 7.15349 11.1632 7.04122 12.0083 7.04027C12.8533 7.04027 13.7148 7.15725 14.5102 7.37419C16.4159 6.0721 17.2609 6.33924 17.2609 6.33924C17.8079 7.72471 17.4596 8.75987 17.3603 9.01021C18.0066 9.71125 18.3876 10.6126 18.3876 11.7144C18.3876 15.5873 16.0514 16.4385 13.8143 16.689C14.179 17.0061 14.4936 17.607 14.4936 18.5586C14.4936 19.9107 14.4773 20.9958 14.4773 21.3295C14.4773 21.5967 14.6596 21.914 15.1566 21.8138C19.1333 20.4781 22 16.7056 22 12.2487C22.0163 6.67296 17.526 2.16602 12.0083 2.16602Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubLogo);
export default __webpack_public_path__ + "static/media/github-logo.6d54f0a1ce22017323c67e66ffaa7b65.svg";
export { ForwardRef as ReactComponent };